import React from 'react';
import { Col, Row } from 'react-bootstrap';

class CodeTable extends React.Component {

    render() {
        return this.props.items.map((c, i) => {
            return (
                <React.Fragment key={i}>
                    <Row>
                        <Col md={6} className="text-right">
                            <span>{c.toString()}</span>
                        </Col>
                        <Col md={6} className="text-right">
                            <span>{this.props.function(c)}</span>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        })
    }
}

export default CodeTable;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Coding/CodeTable.js